export function timeRange(value: string) {
    const LABEL_FORM_DATA = '{value:%l%P}';
    const data = {
        tickIntervalData: 60 * 60 * 1000,
        labelFormatData: LABEL_FORM_DATA
    };
    switch (value) {
        case 'Last 24 hours':
            data.tickIntervalData = 60 * 60 * 1000;
            data.labelFormatData = LABEL_FORM_DATA;
            break;
        case 'Last hour':
            data.tickIntervalData = 5 * 60 * 1000;
            data.labelFormatData = '{value:%I:%M}';
            break;
        case 'Last 7 days':
            data.tickIntervalData = 24 * 60 * 60 * 1000;
            data.labelFormatData = '{value:%e %b}';
            break;
        case 'Last 30 days':
            data.tickIntervalData = 7 * 24 * 60 * 60 * 1000;
            data.labelFormatData = '{value:%e %b}';
            break;
        default:
            data.tickIntervalData = 60 * 60 * 1000;
            data.labelFormatData = LABEL_FORM_DATA;
    }
    return data;
}
